module.exports = __webpack_public_path__ + "static/img-tour-15e42c75682253b4824e5813f4cfa2f9.jpg";